module.exports = __webpack_public_path__ + "img/static_profile_logo.27f0047b.png";